import SettingsImages from "@/views/admin/settings/Images";

export default {
  path: "settings/images",
  name: "settings-images",
  component: SettingsImages,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
